import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }: { children: ReactNode }) {
  const { isAutenticado } = useAuth();
  return isAutenticado ? <>{children}</> : <Navigate to="/login" replace />;
}
